module.exports = __webpack_public_path__ + "static/media/roboto-mono-v5-latin-italic.55befc28.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/roboto-mono/roboto-mono-v5-latin-italic.woff2
// module id = 488
// module chunks = 0